import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useWarehousesList() {
    const toast = useToast()
    const records = ref(null)

    const columns = [
        { key: 'name', label: 'Warehouse', sortable: true },
        { key: 'code', label: 'Code', sortable: true },
        { key: 'location', label: 'Location', sortable: true },
        { key: 'stockBaales', label: 'Warehouse Qty', sortable: true, thClass: 'text-right', tdClass: 'text-right', },
        { key: 'stockMass', label: 'Warehouse Mass', sortable: true, thClass: 'text-right', tdClass: 'text-right', },
        { key: 'transitBales', label: 'Transit Qty', sortable: true, thClass: 'text-right', tdClass: 'text-right', },
        { key: 'transitMass', label: 'Transit Mass', sortable: true, thClass: 'text-right', tdClass: 'text-right', },
        'actions',
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('name')
    const isSortDirDesc = ref(true)

    const refetch = () => {
        console.log('seasons refetch', records.value)
        records.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-warehouse/list', {
                storage_only: true,
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { warehouses, meta } = response.data

                meta.value = meta

                callback(warehouses)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching warehouses list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    return {
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
        fetch,
        refetch,
    }
}